import { Icon } from 'antd'
import styled from 'styled-components'

const WrapIcon = styled(Icon)`
  cursor: pointer;
  font-size: 18px;
  transition: color 0.3s;
  &:hover {
    color: #fa8c16;
  }
`

export { WrapIcon }
